import { render, staticRenderFns } from "./anchorAdd.vue?vue&type=template&id=78e6eb46&scoped=true&"
import script from "./anchorAdd.vue?vue&type=script&lang=js&"
export * from "./anchorAdd.vue?vue&type=script&lang=js&"
import style0 from "./anchorAdd.vue?vue&type=style&index=0&id=78e6eb46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e6eb46",
  null
  
)

export default component.exports